export interface MapWidgetInitializer {
  addressCity: string;
  href: string;
  imgSource: string;
  latitude: number;
  longitude: number;
}

export default class MapWidget {
  public readonly addressCity: string;
  public readonly href: string;
  public readonly imgSource: string;
  public readonly latitude: number;
  public readonly longitude: number;

  constructor(init: MapWidgetInitializer) {
    this.addressCity = init.addressCity;
    this.href = init.href;
    this.imgSource = init.imgSource;
    this.latitude = init.latitude;
    this.longitude = init.longitude;
  }
}
